import { render, staticRenderFns } from "./Apoio.vue?vue&type=template&id=7f255405&scoped=true"
import script from "./Apoio.vue?vue&type=script&lang=js"
export * from "./Apoio.vue?vue&type=script&lang=js"
import style0 from "./Apoio.vue?vue&type=style&index=0&id=7f255405&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ac4a2b9949c4313c2020f7aba7a6f905/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f255405",
  null
  
)

export default component.exports